import * as constants from './constants'

const INITIAL_STATE = {
  loading: false,
  count: {
    meta: {
      code: 200,
      message: '',
      errors: []
    },
    data: {
      data: [],
      pagination: {
        page: 1,
        limit: 10,
        total_page: 1,
        total_data: 1
      }
    }
  },
  visit: {
    meta: {
      code: 200,
      message: '',
      errors: []
    },
    data: {
      data: [],
      pagination: {
        page: 1,
        limit: 10,
        total_page: 1,
        total_data: 1
      }
    }
  },
  revenueMonth: {
    meta: {
      code: 200,
      message: '',
      errors: []
    },
    data: {
      data: [],
      pagination: {
        page: 1,
        limit: 10,
        total_page: 1,
        total_data: 1
      }
    }
  },
  statistic: {
    meta: {
      code: 200,
      message: '',
      errors: []
    },
    data: {
      data: [],
      pagination: {
        page: 1,
        limit: 10,
        total_page: 1,
        total_data: 1
      }
    }
  },
  revenue: {
    meta: {
      code: 200,
      message: '',
      errors: []
    },
    data: {
      data: [],
      pagination: {
        page: 1,
        limit: 10,
        total_page: 1,
        total_data: 1
      }
    }
  },
  transaction: {
    meta: {
      code: 200,
      message: '',
      errors: []
    },
    data: {
      data: [],
      pagination: {
        page: 1,
        limit: 10,
        total_page: 1,
        total_data: 1
      }
    }
  },
  topRevenue: {
    meta: {
      code: 200,
      message: '',
      errors: []
    },
    data: {
      data: [],
      pagination: {
        page: 1,
        limit: 10,
        total_page: 1,
        total_data: 1
      }
    }
  },
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.SET_LOADING:
      return Object.assign({}, state, {
        loading: action.data
      })
    case constants.SET_COUNT:
      return Object.assign({}, state, {
        count: action.data
      })
    case constants.SET_VISIT:
      return Object.assign({}, state, {
        visit: action.data
      })
    case constants.SET_REVENUE_MONTH:
      return Object.assign({}, state, {
        revenueMonth: action.data
      })
    case constants.SET_STATISTIC:
      return Object.assign({}, state, {
        statistic: action.data
      })
    case constants.SET_REVENUE:
      return Object.assign({}, state, {
        revenue: action.data
      })
    case constants.SET_TRANSACTION:
      return Object.assign({}, state, {
        transaction: action.data
      })
    case constants.SET_TOP_REVENUE:
      return Object.assign({}, state, {
        topRevenue: action.data
      })
    default: return state
  }
}
